import { render, staticRenderFns } from "./detalhe_plano.vue?vue&type=template&id=46d631f9&scoped=true&"
import script from "./detalhe_plano.vue?vue&type=script&lang=js&"
export * from "./detalhe_plano.vue?vue&type=script&lang=js&"
import style0 from "./detalhe_plano.vue?vue&type=style&index=0&id=46d631f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d631f9",
  null
  
)

export default component.exports